<template>
  <div v-if="data">
    <footer class="py-4 bg-cyan">
      <div v-if="!routeBlacklist()">
        <div class="text-center" v-html="data.bottom.bottomLoginText"></div>
        <p class="text-center">
          <button @click="$router.push('/login-tr')"
            class="btn btn-share btn-dark btn-sm" v-html="data.startpage.loginResultsBtnText"></button>
        </p>
      </div>
      <div v-if="$route.name === 'testresult'">
        <p class="text-center">
          <button @click="logOut()"
            class="btn btn-share btn-dark btn-sm" v-html="data.startpage.logoutResultsBtnText"></button>
        </p>
      </div>
      <div class="clearfix--min"></div>
      <div class="text-center" v-html="data.bottom.bottomText"></div>
      <p class="text-center">
        <button @click="shareCheckMe()"
          class="btn btn-share btn-info btn-sm" v-html="data.bottom.shareBtnText"></button>
      </p>
      <div class="text-center" v-html="data.bottom.copyrightText"></div>
      <img
        :src="require( `../assets/img/karolinska.svg`)"
        alt="Logotyp för Karolinska"
        class="img-footer"
      />
    </footer>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'

export default {
  name: 'bottom',
  data () {
    return {
      data: null,
      currentYear: new Date().getFullYear()
    }
  },
  methods: {
    logOut () {
      sessionStorage.clear()
      document.location.href = '/'
    },
    routeBlacklist () {
      const blacklist = ['startpage', 'logintestresult', 'loginconfirm', 'loginentercode', 'testresult']
      return blacklist.includes(this.$route.name)
    },
    async shareCheckMe () {
      const shareData = {
        title: 'CheckMe',
        text: this.data.bottom.shareThisTest,
        url: 'https://www.checkme.nu/'
      }
      try {
        await navigator.share(shareData)
      } catch (err) {
        console.log('Could not share: ' + err)
      }
    }
  },
  computed: {
    getCurrentYear () {
      return new Date().getFullYear()
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          bottom(locale: ` + sessionStorage.getItem('language') + `) {
            bottomText
            bottomLoginText
            copyrightText
            shareBtnText
            shareThisTest
          }
          startpage(locale: ` + sessionStorage.getItem('language') + `) {
            loginResultsBtnText
            logoutResultsBtnText
          }
        }
      `
    })
    if (this.data) {
      this.data.bottom.copyrightText = this.data.bottom.copyrightText.replace('{currentYear}', this.currentYear)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
footer {
  position: relative !important;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
  width: 100%;
}
footer p {
  color: rgb(72 58 58) !important;
}
footer a {
  color: rgba(58, 46, 189, 0.575) !important;
}
.btn-share {
  min-width: 11vw;
}
.bg-cyan {
  background: #B1DDC9 !important;
}
.img-footer {
  height: 40px;
}

@media screen and (max-width: 800px) {
  footer {
    margin-top: 50px;
    padding-left: 15px;
  }
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
    .btn-dark {
      min-width: 29vw;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue